// Chapman University's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Undergraduate Degrees by School/College
// page (catalog.chapman.edu, catoid=59; read in a headless browser behind its bot
// check). Every program under a Bachelor heading is kept, under its school or college.
// A program listed by two schools (Screen Acting, Global Communication and World
// Languages) is kept once, under the first. The Music B.A. emphases and the B.M.
// Performance emphases are folded into one line each. The joint mathematics and civil
// engineering program with UC Irvine, minors, certificates and integrated master's
// programs are left out.
const majors = {
    "slug": "chapman-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Chapman's official 2026-2027 Undergraduate Catalog, grouped by the school or college that offers it, with the degree. Minors, certificates and integrated master's programs are left out.",
    "groups": [
        {
            "name": "The George L. Argyros College of Business and Economics",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Business Administration, Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, General Business",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Real Estate",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Donna Ford Attallah College of Educational Studies",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Community Educational Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Crean College of Health and Behavioral Sciences",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Lawrence and Kristina Dodge College of Film and Media Arts",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Film and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Public Relations, Advertising and Entertainment Marketing",
                    "degree": "B.A."
                },
                {
                    "name": "Animation and Visual Effects",
                    "degree": "B.F.A."
                },
                {
                    "name": "Creative Producing",
                    "degree": "B.F.A."
                },
                {
                    "name": "Documentary, Sports Media, and Journalism",
                    "degree": "B.F.A."
                },
                {
                    "name": "Film and Television Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Screen Acting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Writing for Film and Television",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "Dale E. and Sarah Ann Fowler School of Engineering",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Schmid College of Science and Technology",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Wilkinson College of Arts, Humanities, and Social Sciences",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Creative and Cultural Industries",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Global Communication and World Languages",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Peace and Justice Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.F.A."
                },
                {
                    "name": "Design",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "School of Communication",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Strategic Communication",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Performing Arts",
            "source": {
                "label": "Chapman 2026-2027 Undergraduate Catalog, Undergraduate Degrees by School/College",
                "url": "https://catalog.chapman.edu/content.php?catoid=59&navoid=3173"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Dance Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music (Pre-Music Education Certification)",
                    "degree": "B.M."
                },
                {
                    "name": "Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Performance",
                    "degree": "B.M."
                }
            ]
        }
    ]
};

export default majors;
